import { useCallback, useRef, useState } from 'react';

export const useDropdownList = <RefEl extends HTMLElement>() => {
    const controlRef = useRef<RefEl | null>(null);

    const [isDropdownOpen, setDropdownOpen] = useState(false);

    const open = useCallback(() => {
        setDropdownOpen(true);
    }, []);

    const close = useCallback(() => {
        setDropdownOpen(false);
    }, []);

    const findDropdownPosition = (dropdownWidth: number): { posX: number; posY: number } => {
        let posX = 0;
        let posY = 0;

        if (controlRef?.current) {
            const elRect = controlRef.current.getBoundingClientRect();

            posY = elRect.height + window.scrollY + elRect.top;
            posX = elRect.left + elRect.width - dropdownWidth + window.scrollX;
        }

        return { posX, posY };
    };

    return {
        isOpen: isDropdownOpen,
        open,
        close,
        findDropdownPosition,
        controlRef,
    };
};
